import { Color } from '../../types/color';

let primaryColor: Color | null = null;
let lightPurple: Color | null = null;
let darkPurple: Color | null = null;

export const getPrimaryColor = () => {
  if (primaryColor) return primaryColor;
  primaryColor = getComputedStyle(
    document.querySelector('html') || document.createElement('div')
  ).getPropertyValue('--van-primary-color') as Color;
  return primaryColor;
};

export const getLightPurple = () => {
  if (lightPurple) return lightPurple;
  lightPurple = getComputedStyle(
    document.querySelector('html') || document.createElement('div')
  ).getPropertyValue('--light-purple') as Color;
  return lightPurple;
};

export const getDarkPurple = () => {
  if (darkPurple) return darkPurple;
  darkPurple = getComputedStyle(
    document.querySelector('html') || document.createElement('div')
  ).getPropertyValue('--dark-purple') as Color;
  return darkPurple;
};
